export var KeyboardEventKey;

(function (KeyboardEventKey) {
  KeyboardEventKey["ENTER"] = "Enter";
  KeyboardEventKey["ESCAPE"] = "Escape";
  KeyboardEventKey["ARROW_UP"] = "ArrowUp";
  KeyboardEventKey["ARROW_DOWN"] = "ArrowDown";
  KeyboardEventKey["ARROW_LEFT"] = "ArrowLeft";
  KeyboardEventKey["ARROW_RIGHT"] = "ArrowRight";
  KeyboardEventKey["CAPS_LOCK"] = "CapsLock";
  /* IE/Edge */

  KeyboardEventKey["ESC"] = "Esc";
  KeyboardEventKey["UP"] = "Up";
  KeyboardEventKey["DOWN"] = "Down";
  KeyboardEventKey["LEFT"] = "Left";
  KeyboardEventKey["RIGHT"] = "Right";
})(KeyboardEventKey || (KeyboardEventKey = {}));